import {
  type GetCalendarAnswerCountsResponse,
  type GetDateAnswersResponse,
  type GetOldestAnswerDateResponse,
} from '@coorum-research/shared-common/types/calendar.type'
import { formatDate } from '@coorum-research/shared-common/utils/date.util'

import http from './http'


/**
 * GET: /calendars/answer-counts
 * @param year 
 * @param month 
 * @returns 
 */
export const getCalendarAnswerCounts = async (year: number, month: number) => {
  const response = await http.get<GetCalendarAnswerCountsResponse>(
    '/calendars/answer-counts',
    { params: { year, month } }
  )
  return response.data
}

/**
 * GET: /calendars/date-answers
 * @param date 
 * @returns 
 */
export const getDateAnswers = async (date: Date) => {
  const response = await http.get<GetDateAnswersResponse>(`/calendars/date-answers`, {
    params: {
      date: formatDate(date, 'yyyy-MM-dd')
    },
  })
  return response.data
}

/**
 * GET: /calendars/oldest-answer-date
 * @returns 
 */
export const getOldestAnswerDate = async () => {
  const response = await http.get<GetOldestAnswerDateResponse>('/calendars/oldest-answer-date')
  return response.data
}
